export default __webpack_public_path__ + "../img/660d39bca48249d4f01786e54b214684.png";